import Box from '~/common/components/Box';
import Flex from '~/common/components/Flex';
import Text from '~/common/components/Texts/Text';
import type { RecentRaiseData } from '~/pages/IncomeCalculator/Pages/ReviewBreakdown/RecentRaise/types';

import FormulaDisplay from './FormulaDisplay';

type RecentRaiseYearSectionProps = RecentRaiseData & {
  throughDateUsedForCalculation: string;
  isLpaRecentRaise?: boolean;
};

type MonthsRowProps = {
  label: string;
  value: string;
};
function MonthsRow({ label, value }: Readonly<MonthsRowProps>) {
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      borderBottom="1px solid"
      mr={4}
      borderColor="gray.300"
      pb={2}
      mb={2}
      ml={4}
    >
      <Text fontWeight="bold" fontSize="md">
        {label}
      </Text>
      <Text fontSize="md">{value}</Text>
    </Flex>
  );
}

export default function RecentRaiseYearSection({
  title,
  monthsAtPriorRate,
  monthsAtCurrentRate,
  incomeYear,
  monthsUsedForCalculation,
  calculationFormula,
  throughDateUsedForCalculation,
  isLpaRecentRaise = false,
}: Readonly<RecentRaiseYearSectionProps>) {
  const monthsNeededLabel =
    incomeYear === 'Ytd' && throughDateUsedForCalculation
      ? `Months Through ${throughDateUsedForCalculation}`
      : 'Months Needed';

  const monthsItems = [
    {
      id: 'monthsNeeded',
      label: monthsNeededLabel,
      value: monthsUsedForCalculation,
    },
    {
      id: 'monthsPriorRate',
      label: 'Months at Prior Rate',
      value: monthsAtPriorRate,
    },
    {
      id: 'monthsCurrentRate',
      label: 'Months at Current Rate',
      value: monthsAtCurrentRate,
    },
  ];

  return (
    <Box
      width="100%"
      borderWidth="2px"
      borderColor="gray.300"
      borderRadius="md"
    >
      <Box bg="gray.100" p={3} mb={3} borderRadius="md">
        <Text fontSize="lg" fontWeight="bold">
          {title}
        </Text>
      </Box>

      <Box mb={3} mt={6}>
        {monthsItems.map((item) => (
          <MonthsRow key={item.id} label={item.label} value={item.value} />
        ))}
      </Box>

      <FormulaDisplay
        calculationFormula={calculationFormula}
        incomeYear={incomeYear}
        isLpaRecentRaise={isLpaRecentRaise}
      />
    </Box>
  );
}
